import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-circle",
  "use": "info-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"info-circle\"><g class=\"is-icon-target\"><path d=\"m10 20c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10z\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(2 2)\" /><path d=\"m0 4v-4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(12 12)\" /></g><g class=\"is-icon-dot\"><circle cx=\"12\" cy=\"8\" r=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol